export default __webpack_public_path__ + "static/banner-one-shape1-02751e2ad01c5479164de9917e609964.png";